if (!customElements.get('dope-pairing-form')) {
  customElements.define('dope-pairing-form', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('select[name="id"]');
      if (!this.select) return;
      this.onChange = () => this.update();
      this.select.addEventListener('change', this.onChange);
      const button = this.querySelector('[type="submit"]');
      if (button) {
        this.busyObserver = new MutationObserver(() => {
          // Keep the chosen variant in FormData: native buttons mark busy before submit.
          const busy = button.getAttribute('aria-busy') === 'true';
          this.select.inert = busy;
          this.select.setAttribute('aria-disabled', String(busy));
        });
        this.busyObserver.observe(button, {attributes: true, attributeFilter: ['aria-busy']});
      }
      this.update();
    }
    disconnectedCallback() {
      this.select?.removeEventListener('change', this.onChange);
      this.busyObserver?.disconnect();
      this.ready = false;
    }
    update() {
      const option = this.select.selectedOptions[0];
      if (!option) return;
      const quantity = this.querySelector('[name="quantity"]');
      const price = (this.closest('dialog') || this.closest('article'))?.querySelector('[data-pairing-price]');
      const button = this.querySelector('[type="submit"]');
      if (quantity) quantity.value = option.dataset.quantityMin;
      if (price) price.textContent = option.dataset.price;
      const form = this.querySelector('form');
      if (typeof form?.toggleSubmitButton === 'function') {
        form.toggleSubmitButton(option.disabled);
        form.handleErrorMessage();
      } else if (button) {
        button.disabled = option.disabled;
      }
    }
  });
}
